export const SceneStartTransition = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform sampler2D uTextureOne;
uniform float progress;
void main(void) {
  if(progress >0.1){
    vec2 uv= vTextureCoord;
    vec4 color = texture2D(uSampler,uv);
    vec4 color2 = texture2D(uTextureOne,uv);
    vec3 diff =  (1.0/color2.rgb)*(progress);
    vec3 newcolor= color.rgb;
    if((color.r*(diff.r-(1.0-progress))) <= color.r && (color.g*(diff.g-(1.0-progress))) <= color.g  && (color.b*(diff.b-(1.0-progress))) <= color.b  ){
      newcolor= vec3((color.r*(diff.r-(1.0-progress))),(color.g*(diff.g-(1.0-progress))),(color.b*(diff.b-(1.0-progress))));
    }
    gl_FragColor =vec4(newcolor, 1.0);;
  }
  else{
    gl_FragColor= vec4(0.0,0.0,0.0,1.0);
  }
}
`;